import HubspotAPI from "../HubspotIntegration/HubspotAPI";
//////////////
// HS Ticket
export class HSTicket {
    constructor(ticket) {
        this.dbId = HubspotAPI.getDbIdFromContent(ticket.properties.content);
        this.hubspotTicketId = ticket.id;
        this.description = ticket.properties.content;
        this.date = ticket.properties.createdate;
        this.title = ticket.properties.subject;
        this.email = HubspotAPI.getUserEmailFromContent(ticket.properties.content) || "";
        this.serialNumber = HubspotAPI.getSerialNumberFromContent(ticket.properties.content) || "";
        this.status = HubspotTicketStatusMap[ticket.properties.hs_pipeline_stage];
    }
}
export var HubspotTicketStatus;
(function (HubspotTicketStatus) {
    HubspotTicketStatus["OPEN"] = "Open";
    HubspotTicketStatus["CLOSED"] = "Closed";
    HubspotTicketStatus["IN_PROGRESS"] = "In progress";
})(HubspotTicketStatus || (HubspotTicketStatus = {}));
export const HubspotTicketStatusMap = {
    [HubspotTicketStatus.OPEN]: "1",
    [HubspotTicketStatus.CLOSED]: "4",
    [HubspotTicketStatus.IN_PROGRESS]: "81777681",
    "1": HubspotTicketStatus.OPEN,
    "4": HubspotTicketStatus.CLOSED,
    "81777681": HubspotTicketStatus.IN_PROGRESS,
};
//////////////
